import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of, catchError, map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { LoggerService } from '../../logger/logger.service';
import { SessionService } from '../../session/session.service';
import { BillingApiCommonService } from '../billing-api-common.service';
import { SmartMilesEnrollmentResponse } from './smart-miles.model';

@Injectable({
    providedIn: 'root'
})
export class SmartMilesService {

    constructor(
        private http: HttpClient,
        private session: SessionService,
        private apiCommon: BillingApiCommonService,
        @Inject('logger') private logger: LoggerService
    ) { }

    getEnrolledVehicles(policyNumbers: string[]): Observable<SmartMilesEnrollmentResponse[]> {
        if (!policyNumbers || policyNumbers.length === 0) {
            return of([]);
        }

        const url = `${environment.SMART_MILES.url}${environment.SMART_MILES.searchUri}`;
        return this.http.get<SmartMilesEnrollmentResponse[]>(url, {
            headers: this.buildRequest(),
            params: this.buildPolicyNumberParams(policyNumbers)
        }).pipe(
            map((response) => response || []),
            catchError((error) => {
                this.logger.error('SMART MILES API ERROR: RETRIEVE ENROLLED VEHICLES', { error });
                return of([]);
            })
        );
    }

    private buildPolicyNumberParams(policyNumbers: string[]): HttpParams {
        let params = new HttpParams();
        policyNumbers.forEach((policyNumber) => {
            params = params.append('policyNumber', policyNumber);
        });
        return params;
    }

    private buildRequest(): HttpHeaders {
        let headers = new HttpHeaders()
            .set('Content-Type', 'application/json')
            .set('Accept', 'application/json')
            .set('client_id', environment.SMART_MILES.clientId)
            .set('X-NW-MessageID', this.apiCommon.generateTransactionId());
        if (this.session.accessToken) {
            headers = headers.set('Authorization', `Bearer ${this.session.accessToken}`);
        }
        return headers;
    }
}
